import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrRE: CultureInfo = {
  name: 'fr-RE',
  displayName: 'French (Réunion)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-RE',
  parent: CultureInfoFr
};
